export default {"src":"/_next/static/media/discourse.64cda875.svg","height":106,"width":104,"blurWidth":0,"blurHeight":0};